import React from 'react';

type Props = {
  onGoDashboard: () => void;
  userInitial?: string;
};

export default function Header({ onGoDashboard, userInitial }: Props) {
  return (
    <header className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <button onClick={onGoDashboard} className="mr-4 text-gray-600 hover:text-gray-900 cursor-pointer">
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
            <h1 className="text-2xl font-bold text-indigo-600" style={{ fontFamily: "Pacifico, serif" }}>
              Vibecode
            </h1>
          </div>
          <nav className="hidden md:flex space-x-8">
            <a onClick={onGoDashboard} className="text-gray-700 hover:text-indigo-600 transition-colors cursor-pointer">Dashboard</a>
            <a className="text-indigo-600 font-medium cursor-pointer">Detalhes do Projeto</a>
          </nav>
          <div className="flex items-center space-x-4">
            <div className="w-8 h-8 bg-indigo-600 rounded-full flex items-center justify-center">
              <span className="text-white text-sm font-medium">{userInitial}</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}